module.exports = __webpack_public_path__ + "img/组 131.451838c2.png";